<template>
  <tr>
    <td class="py-10 border-bottom">
      <div class="d-flex align-items-center">
        <UserAvatar
          :name="user.fullName"
          :email="user.email"
          size="large"
          class="mr-16"
        />
        <div>{{ user.fullName }}</div>
      </div>
    </td>
    <td class="py-10 border-bottom">
      {{ user.email }}
    </td>
    <td class="py-10 border-bottom text-right">
      <b-spinner v-if="user.isLoading" small class="mr-8" />

      <b-dropdown
        v-if="user.id !== $user.id && !user.isLoading"
        right
        no-caret
        variant="link"
      >
        <template slot="button-content">
          <i class="icon-more-h-2 fs20"></i>
        </template>
        <b-dropdown-item-button @click="$emit('resend', user)"
          >Reset password</b-dropdown-item-button
        >
        <b-dropdown-item-button @click="$emit('remove', user)"
          >Delete user</b-dropdown-item-button
        >
      </b-dropdown>
    </td>
  </tr>
</template>

<script>
import UserAvatar from '@/components/user/UserAvatar'

export default {
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    $user() {
      return this.$store.state.user.data
    }
  }
}
</script>
